import React, { useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

const ContactFormModal = ({ affiliateMember, affiliateMemberDetail, organization }) => {
  const dispatch = useDispatch();
  const ui = useSelector(state => state.ui);
  const affiliateMemberContacts = useSelector(state => state.affiliateMemberContacts);
  const contact = ui.contactModal?.contact || {};
  const orgName = organization?.name;
  const isEdit = contact.id !== undefined && ui.contactModal?.action === 'edit';

  useEffect(() => {
    if (affiliateMemberDetail?.contacts &&
        (!affiliateMemberContacts || affiliateMemberContacts.length === 0)) {
      dispatch({
        type: 'SET_AFFILIATE_MEMBER_CONTACTS',
        payload: affiliateMemberDetail.contacts || []
      });
    }
  }, [affiliateMemberDetail?.contacts, affiliateMemberContacts, dispatch]);

  useEffect(() => {
    if (ui.contactModal?.show) {
      dispatch({
        type: 'UPDATE_RESOURCE_FIELD',
        payload: {
          resourceName: 'contact',
          value: affiliateMemberDetail?.id,
        },
      });
    }
  }, [ui.contactModal?.show, affiliateMemberDetail?.id, dispatch]);

  const handleClose = () => {
    dispatch({ type: 'CLOSE_RESOURCE_MODAL', payload: { resourceName: 'contact' } });

    if (ui.contactModal?.contact) {
      dispatch({
        type: 'UPDATE_RESOURCE_FIELD',
        payload: {
          resourceName: 'contact',
          name: 'name',
          value: ''
        }
      });
      dispatch({
        type: 'UPDATE_RESOURCE_FIELD',
        payload: {
          resourceName: 'contact',
          name: 'title',
          value: ''
        }
      });
      dispatch({
        type: 'UPDATE_RESOURCE_FIELD',
        payload: {
          resourceName: 'contact',
          name: 'email',
          value: ''
        }
      });
      dispatch({
        type: 'UPDATE_RESOURCE_FIELD',
        payload: {
          resourceName: 'contact',
          name: 'phone',
          value: ''
        }
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const memberId = affiliateMember?.id;

    try {
      let contactsToSubmit;

      if (isEdit) {
        contactsToSubmit = affiliateMemberContacts.map(c =>
          c.id === contact.id ? contact : c
        );
      } else {
        contactsToSubmit = [...(affiliateMemberContacts || []), contact];
      }

      const response = await fetch(
        `/organizations/${orgName}/affiliate_members/${memberId}/detail`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          },
          body: JSON.stringify({
            affiliate_member_details_params: {
              contacts_attributes: contactsToSubmit
            }
          }),
        }
      );

      if (!response.ok) throw new Error('Failed to save contact');

      const data = await response.json();

      if (isEdit) {
        dispatch({
          type: 'SET_AFFILIATE_MEMBER_CONTACTS',
          payload: contactsToSubmit
        });
      } else {
        dispatch({
          type: 'UPDATE_AFFILIATE_MEMBER_CONTACTS',
          payload: contact
        });
      }

      handleClose();
    } catch (error) {
      console.error('Error saving contact:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const allowedPhoneRegex = /^[0-9()+\- ]*$/;
      if (!allowedPhoneRegex.test(value)) {
        return;
      }
    }

    dispatch({
      type: 'UPDATE_RESOURCE_FIELD',
      payload: { resourceName: 'contact', name, value },
    });
  };

  if (!ui.contactModal?.show) return null;

  return (
    <Modal show onHide={handleClose}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>
            {ui.contactModal?.action === 'edit' ? 'Edit Contact' : 'Add Contact'}
          </Modal.Title>
          <p className="mb-0">Every field with an * is required</p>
        </div>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Name *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={contact.name || ''}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={contact.title || ''}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={contact.email || ''}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  value={contact.phone || ''}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              {ui.contactModal?.action === 'edit' ? 'Update' : 'Save'} Contact
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ContactFormModal;
